import React from 'react';
import './styles.scss';
import { EditAltIcon, DeleteIcon } from 'cokitchen-icons';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';
import useDashboardContext from 'contexts/dashboard.context';
import MoveBrandMenu from 'components/move-brand-menu';
import { ENUM_BRAND_TYPE } from 'utils/enum';

type SearchNavProps = {
  count: number;
  isBrand?: boolean;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onRestoreClick?: () => void;
  onDoneClick: () => void;
  handleSelectAll: () => void;
  onMoveBrand?: (type: ENUM_BRAND_TYPE) => void;
};
const SearchNav = ({
  count,
  onEditClick,
  onRestoreClick,
  onDeleteClick,
  onDoneClick,
  handleSelectAll,
  onMoveBrand,
  isBrand
}: SearchNavProps) => {
  const { trash } = useDashboardContext();

  return (
    <div className='search_nav'>
      <div className='search_nav_content'>
        <label>
          {count} {count === 1 ? 'item' : 'items'} selected
        </label>

        <div className='search_nav_actions'>
          {isBrand && onMoveBrand && <MoveBrandMenu onMoveBrand={onMoveBrand} />}

          <button onClick={handleSelectAll} className='search_nav_btn'>
            Select all
          </button>

          {trash ? (
            <button onClick={onRestoreClick} className='search_nav_btn capitalize'>
              <RestoreIcon /> Restore
            </button>
          ) : (
            <button onClick={onEditClick} className='search_nav_btn capitalize'>
              <EditAltIcon /> Edit
            </button>
          )}

          {!trash && (
            <button onClick={onDeleteClick} className='search_nav_btn'>
              <DeleteIcon />
              Archive
            </button>
          )}
        </div>

        <button onClick={onDoneClick} className='search_nav_done_btn'>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default SearchNav;
